import React from 'react';

import { QAlityFreeLabel } from '@qality/common-components/src/atoms/QAlityFreeLabel';
import { TextExecutionDetailsHistory } from '@qality/common-components/src/molecules/TextExecutionDetails/TextExecutionDetailsHistory';

export const QAlityFreeTextExecutionDetailsView = ({
  executionsCount,
  executionsHistoryUrl,
}: any) => {
  return (
    <>
      <TextExecutionDetailsHistory
        executionsCount={executionsCount}
        executionsHistoryUrl={executionsHistoryUrl}
      />
      <QAlityFreeLabel
        text='More details in QAlity Plus. '
        linkName='Learn more'
        linkUrl='https://soldevelo.atlassian.net/wiki/spaces/QS/pages/2444165210/QAlity+vs+QAlity+Plus'
      />
    </>
  );
};
